<template>
  <div>
    <Header />

    <section
      v-if="payment && payment.pdf_policy && payment.insurance_start_date"
      id="comparer_form"
      class="px-4 pb-32 bg-gray-100"
      :class="this.$store.state.isInIframe ? 'pt-32' : ''"
    >
      <div class="relative z-40 max-w-6xl mx-auto">
        <div
          class="md:p-[60px] p-5 rounded-lg shadow-0-2-5 bg-white relative -top-5"
        >
        <div class="lg:flex items-end">
          <div class="lg:w-1/2">
              <h2 class="text-[28px] font-bold mb-5">
            Dziękujemy za wybór Punkty!
          </h2>
          <h4 class="mb-10 text-[22px]">
            Twoja polisa będzie ważna od
            <strong
              >{{
                this.$moment(payment.insurance_start_date, 'DD/MM/YYYY').format(
                  'DD.MM.YYYY'
                )
              }}, 00:00.</strong
            >
          </h4>

          <div class="md:w-[310px]">
            <a
              :href="'/' + payment.pdf_policy"
              class="flex items-center justify-center py-4 text-sm font-bold text-white bg-orange-100 rounded-lg hover:bg-opacity-70 hover:text-white mb-7"
            >
              <div class="mx-1">Pobierz polisę w formacie pdf</div>
              <img
                class="mx-1"
                src="@/assets/img/punkta_comparer/download-icon.svg"
                alt="arrow"
              />
            </a>
          </div>
          <p class="text-sm mb-9 lg:hidden block">
            Polisa jest zabezpieczona hasłem. Hasłem jest PESEL osoby
            ubezpieczającej wyjazd.
          </p>

        </div>
          <div class="lg:w-1/2">
            <a v-if="this.$store.state.isInIframe" href="https://autopay.pl/" class="flex items-center justify-center w-full btn-autopay py-4 mx-auto text-sm font-bold text-white bg-red-100 rounded-lg md:mx-0 mb-7 hover:bg-opacity-70 hover:text-white md:w-60"><div class="mx-1">Wróć do strony Autopay</div><img src="/app/themes/punkta/assets/comparer/travel/img/arrow-right.630a2278.svg" alt="arrow" class="mx-1"></a>
          </div>
        </div>
          <p class="text-sm mb-9 lg:block hidden">
            Polisa jest zabezpieczona hasłem. Hasłem jest PESEL osoby
            ubezpieczającej wyjazd.
          </p>
          <div class="pt-10 border-t border-black border-opacity-20 policy-finish-check">
            <div class="p-5 bg-gray-100 md:p-0">
              <a href="https://app.autopay.eu/e-winieta" target="_blank"
                class="flex flex-wrap items-center justify-between md:flex-nowrap"
              >
              <img src="@/assets/img/punkta_comparer/banner_autopay.png" alt="">
                <!-- <div class="mx-auto text-center md:pl-10 md:mx-0 md:text-left">
                  <h3 class="mb-5 text-[22px]">
                    Sprawdź ubezpieczenia, które mogą Cię zainteresować
                  </h3>

                  <a
                    href="/"
                    class="flex items-center justify-center w-full py-4 mx-auto text-sm font-bold text-white bg-red-100 rounded-lg md:mx-0 mb-7 hover:bg-opacity-70 hover:text-white md:w-60"
                  >
                    <div class="mx-1">Sprawdź ubezpieczenia</div>
                    <img
                      class="mx-1"
                      src="@/assets/img/punkta_comparer/arrow-right.svg"
                      alt="arrow"
                    />
                  </a>
                </div>

                <img
                  class="hidden md:inline-block"
                  src="@/assets/img/punkta_comparer/punkta-circles.svg"
                  alt="circle"
                />
                <img
                  class="inline-block mx-auto md:hidden"
                  src="@/assets/img/punkta_comparer/punkta-circles-mobile.svg"
                  alt="circle"
                /> -->
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
//<Form v-bind:services="this.$store.state.services" />
// import Form from './components/Form.vue'
import Header from './components/Header.vue'
export default {
  components: {
    Header
  },
  data () {
    return {
      payment: ''
    }
  },

  mounted () {
    window.scrollTo(0, 0)
    let urlParams = new URLSearchParams(window.location.search)
    this.$store.commit('setStep', 3)
    this.getPaymentStatus(urlParams.get('policy'))
  },
  methods: {
    getPaymentStatus (payment_token) {
      let _this = this
      var count = 0
      _this.$store.commit('setLoader', true)

      const cancelTokenSource = _this.axios.CancelToken.source()
      var interval = setInterval(() => {
        _this.axios
          .post(
            // '/wp-json/travel/v1/getQuotationStatus',
            '/wp-json/travel/v1/getPaymentStatus',
            {
              payment_token: payment_token
            },
            { cancelToken: cancelTokenSource.token }
          )
          .then(function (response) {
            count++
            if (response && response.data) {
              if (response.data == 1) {
                cancelTokenSource.cancel()
                clearInterval(interval)

                _this.getPayment(payment_token)
              }
            }
            if (count > 90) {
              _this.$store.commit('setLoader', false)
              _this.$store.commit('setShowModal', true)
              cancelTokenSource.cancel()
              clearInterval(interval)
            }
          })
          .catch(thrown => {
            if (!this.axios.isCancel(thrown)) {
              console.log(thrown)
              _this.$store.commit('setLoader', false)
              _this.$store.commit('setShowModal', true)
            }
          })
      }, 1000)
    },
    getPayment (payment_token) {
      let _this = this
      _this.$store.commit('setLoader', true)
      this.axios
        .post(
          // '/wp-json/travel/v1/getStarpacks',
          '/wp-json/travel/v1/getPayment',
          { payment_token: payment_token }
        )
        .then(function (response) {
          if (response && response.data && response.data.code == 200) {
            _this.payment = response.data
            // _this.sendEmail(response.data.policy_token)

            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({ ecommerce: null })
            window.dataLayer.push({
              event: 'travelInsuranceCalculator', //stała
              action: 'ecommerce', //stała
              label: 'purchase', //stała wartość checkout + krok checkout
              ecommerce: {
                purchase: {
                  actionField: {
                    id: response.data.event.id, //id transakcji
                    affiliation: 'Online', //stała
                    revenue: response.data.event.revenue, //wartość polisy
                    tax: '0.00', //wysokość podatku
                    shipping: '0.00', //stała bo nie mamy dostawy
                    coupon: '' //wartość kuponu - jeśli jest
                  },
                  products: [
                    {
                      name: 'Oferta nr.: ' + response.data.event.starpack_id, //nazwa oferty
                      id: response.data.event.starpack_id, //id oferty
                      price:  response.data.event.revenue, //cena
                      brand: response.data.event.brand, //nazwa ubezpieczalni
                      category: 'Insurance/Travel', //stała
                      variant: 'Travel', //stała
                      list: 'Travel Search Results', //stała
                      // position: 2 //pozycja na liście ofert
                    }
                  ]
                }
              }
            })

            _this.$store.commit('setLoader', false)
          }
        })
        .catch(function (error) {
          console.log(error)
          _this.$store.commit('setLoader', false)
          _this.$store.commit('setShowModal', true)
        })
    },
    dateTime (value) {
      return this.moment(value).format('YYYY-MM-DD')
    },
    sendEmail (policy_token) {
      let _this = this
      _this.$store.commit('setLoader', true)
      this.axios
        .post('/wp-json/travel/v1/sendEmail', {
          event_name: 'travel_policy_final_documents',
          policy_token: policy_token
        })
        .then(function (response) {
          if (response && response.data && response.data.code == 200) {
            _this.$store.commit('setLoader', false)
          }
        })
        .catch(function (error) {
          console.log(error)
          _this.$store.commit('setLoader', false)
          _this.$store.commit('setShowModal', true)
        })
    }
  }
}
</script>
